'use client'

import { useTranslation } from '@/lib/i18n/useTranslation.client'
import type { SharedUITextInputProps } from '../../_shared/SharedUITextInput.client'
import { TextInput } from '../text/TextInput.client'

type EmailInputOwnProps = SharedUITextInputProps<'required' | 'asyncValidate'> & {
  placeholder?: string
  isDisabled?: boolean
  isReadOnly?: boolean
}

// Regex to validate email address
const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/

const removeNonDigitsRegExp = /\s+/g

/**
 * @example
 * ```tsx
 * <Form.Input.Email
 *  name="email"
 *  label="Email"
 *  required
 *  placeholder="E.g. jane.doe@your-company.com"
 *  message="Invalid email"
 *  asyncValidate={isEmailAvailable}
 * />
 * ```
 */
export function EmailInput({
  name,
  label,
  required,
  placeholder,
  isDisabled,
  isReadOnly,
  ...rules
}: EmailInputOwnProps) {
  const { t } = useTranslation(['EmailInput'])

  function removeSpaces(string: string) {
    return string.replace(removeNonDigitsRegExp, '')
  }

  return (
    <TextInput
      {...rules}
      required={required}
      name={name}
      label={label}
      placeholder={placeholder || ''}
      readOnly={isReadOnly}
      isDisabled={isDisabled}
      type="email"
      autocomplete="email"
      inputMode="email"
      validate={(value) => (EMAIL_REGEX.test(value) ? undefined : t('EmailInput:error.pattern'))}
      onChange={(e) => {
        e.target.value = removeSpaces(e.target.value)
      }}
      onBlur={(e) => {
        e.target.value = removeSpaces(e.target.value)
      }}
    />
  )
}
